import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/Logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-25112eb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Zetreex", -1))
const _hoisted_4 = { class: "change__language_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ru", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line__navigation_1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line__navigation_2" }, null, -1))
const _hoisted_11 = { class: "change__language_container_mobile" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ru", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line__navigation_3" }, null, -1))
const _hoisted_17 = { class: "navigation_lc" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:info@zetreex.com",
  class: "email__zeta"
}, " info@zetreex.com ", -1))
const _hoisted_19 = { class: "lottie__menu" }
const _hoisted_20 = { class: "link_hr" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_hr_links = _resolveComponent("hr-links")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({ container__header: true, active: _ctx.getMenu })
      }, [
        _createVNode(_component_router_link, {
          to: "/about-us",
          onClick: _cache[0] || (_cache[0] = () => _ctx.setMenu(false))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getLanguage === 'ru' ? 'ru_language active' : 'ru_language'),
            onClick: _cache[1] || (_cache[1] = () => _ctx.updateLanguage('ru'))
          }, _hoisted_6, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["en_language", _ctx.getLanguage === 'en' ? 'ru_language active' : 'ru_language']),
            onClick: _cache[2] || (_cache[2] = () => _ctx.updateLanguage('en'))
          }, _hoisted_8, 2)
        ]),
        _createElementVNode("nav", null, [
          _createElementVNode("ul", {
            class: _normalizeClass({ navigation__links: true, active: _ctx.getMenu })
          }, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStaticLanguage.links, (link) => {
              return (_openBlock(), _createElementBlock("li", {
                key: link.path,
                onClick: _cache[3] || (_cache[3] = () => _ctx.setMenu(false))
              }, [
                _createVNode(_component_router_link, {
                  to: link.path,
                  "exact-active-class": "active_link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(link.word), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128)),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(
                  _ctx.getLanguage === 'ru' ? 'ru_language active' : 'ru_language'
                ),
                onClick: _cache[4] || (_cache[4] = () => _ctx.updateLanguage('ru'))
              }, _hoisted_13, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["en_language", 
                  _ctx.getLanguage === 'en' ? 'ru_language active' : 'ru_language'
                ]),
                onClick: _cache[5] || (_cache[5] = () => _ctx.updateLanguage('en'))
              }, _hoisted_15, 2)
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_hr_links, {
                text: 'HR Linkedin',
                link: 'https://www.linkedin.com/in/michael-catcher-8b57521b0/',
                active: false
              }, null, 8, ["link"]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_lottie_animation, { path: "./images/Android.json" })
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_hr_links, {
            text: _ctx.getStaticLanguage.feedback,
            link: 'https://www.linkedin.com/in/michael-catcher-8b57521b0/',
            active: true,
            no_svg: true
          }, null, 8, ["text", "link"])
        ]),
        _createElementVNode("div", {
          class: "menu__zetreex",
          onClick: _cache[6] || (_cache[6] = () => _ctx.setMenu(!_ctx.getMenu))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ menu__zetreex_content: true, active: _ctx.getMenu })
          }, _hoisted_22, 2)
        ])
      ], 2)
    ])
  ]))
}